export default {
  PUBLIC: 'public',
  PRIVATE: 'private',
};
